import React from "react";
import { navigate } from "@reach/router";
import { Box, Text } from "@theme-ui/components";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { HeroSection } from "../molecules";
import { colors } from "../../styles/theme";

const HeroBanner = ({ data, code }) => {
  const bp = useBreakpointIndex({ defaultIndex: 2 });
  const primaryCTA = (e) => {
    const gcName = bp < 2 ? "gc_2001_003" : "gc_2001_002";
    e.preventDefault();
    window.open(
      `signup/?gc_name=${gcName}&gc_source=wgc%2F%home%2F&gc_index=0/`,
      "_parent",
      "noopener,noreferrer"
    );
  };
  return (
    <Box mx={["1.03rem", "1.03rem", "2rem", "3.12rem"]}>
      <HeroSection
        variant="default"
        circleVariant="type3"
        subHeading={
          <Text
            dangerouslySetInnerHTML={{ __html: data?.description }}
            sx={{ p: { m: 0 } }}
          />
        }
        heading={
          <Text
            dangerouslySetInnerHTML={{ __html: data?.title }}
            sx={{ p: { m: 0 } }}
          />
        }
        bgColor={colors.secondaryBlue400}
        primaryBtnLabel={code === "ME" && "Start a greytHR Free Account"}
        primaryBtnId={`home_free_trial_${code.toLowerCase()}_btn`}
        secondaryBtnLabel="Talk to Us!"
        secondaryBtnId={`home_demo_${code.toLowerCase()}_btn`}
        image={data?.image}
        onPrimaryBtnClick={code === "ME" && primaryCTA}
        onSecondaryBtnClick={() => {
          navigate(
            code === "ME"
              ? "/middle-east/demo/?gc_source=home&ac_form_tag=AF_DEMO_HOME_ME"
              : `/demo/?gc_source=home&ac_form_tag=AF_DEMO_HOME_${code}`
          );
        }}
      />
    </Box>
  );
};

export default HeroBanner;
